import React, { useEffect, useState } from 'react'
import SubHeader from '../Shared/Display/SubHeader'
import DateTimeFilter from '../Shared/Buttons/DateTimeFilter'
import FilterBy from '../Shared/Filters/FilterBy'
import CustomFilter from '../Shared/Buttons/CustomFilter'
import AdministratorTable from '../Shared/Data/AdministratorTable'
import { useDispatch, useSelector } from 'react-redux'
import { fetchUsers } from '../Redux/Actions/Content'
import { generateUserReport } from '../Redux/Actions/GenerateReport'
import { componentCreated, updateDateFilter, updateGroupFilter } from '../Redux/Actions/DateFilter'
import { useLocation, useNavigate } from 'react-router'
import { composeFilterString, getDateFilter, getGroupFilter, processDate, processGroup, formatStartEndDates } from '../utils/analytics-utils'
import { addQuery } from '../utils/router-utils'

/** @const {number} pageTotals */
const pageTotals = 10

function Administrator () {
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [page, setPage] = useState(1)
  const [sort, setSort] = useState('lastAdminLogin DESC')

  const id = useSelector(state => state.account.ID)
  const adminList = useSelector(state => state.content.users)
  const adminLength = useSelector(state => state.content.usersLength)
  const userAnalyticsEnabled = useSelector(state => state.account.userAnalyticsEnabled)
  const redirect = useSelector(state => state.account.redirect)
  const status = useSelector(state => state.generateReport.status)
  const dateFilterStore = useSelector(state => state.dateFilter)
  const name = 'Administrator'

  let dateFilterFromStore = getDateFilter(dateFilterStore, name)
  dateFilterFromStore = dateFilterFromStore ? dateFilterFromStore.dateFilter || 'Week' : 'Week'
  const [dateFilter, setDateFilter] = useState(dateFilterFromStore)

  const groupFilterFromStore = getGroupFilter(dateFilterStore, name) || ''
  const [groupFilter, setGroupFilter] = useState(groupFilterFromStore)
  const dateInterval = dateFilter ? dateFilter.dateInterval || null : null

  useEffect(() => {
    dispatch(componentCreated(name))
  }, [])

  useEffect(() => {
    update(processDate(dateFilter), processGroup(groupFilter))
  }, [page, sort])

  useEffect(() => {
    newQuery(location.search.substring(1).split('&'))
  }, [])

  const newQuery = (query) => {
    const qobj = {}
    let newDateFilter
    query.forEach((q) => {
      qobj[q.split('=')[0]] = q.split('=')[1]
    })
    if (dateFilter === 'Custom' && dateInterval) {
      newDateFilter = dateInterval
    } else {
      newDateFilter = dateFilter
    }
    update(processDate(newDateFilter), processGroup(groupFilter), id)
  }

  const update = (date, group, newID) => {
    const ID = newID || id
    const formattedDate = formatStartEndDates(date)
    dispatch(fetchUsers(ID, formattedDate.start, formattedDate.end,
      {
        limit: pageTotals,
        offset: (page - 1) * pageTotals,
        group: group.groups,
        profile: group.profiles,
        adminType: group.alt,
        sort,
        onlyAdmins: true
      }))
  }

  const changeDateFilter = (newFilter, isCustom) => {
    if (isCustom) {
      dispatch(updateDateFilter(name, 'Custom', newFilter))
    } else {
      dispatch(updateDateFilter(name, newFilter))
    }
    const f = `${composeFilterString(groupFilter.profiles, groupFilter.groups)}_${groupFilter.alt || ''}`
    addQuery({ date: newFilter, filter: f }, location, navigate)
    setDateFilter(newFilter)
    if (newFilter !== 'Custom') {
      update(processDate(newFilter), processGroup(groupFilter))
    }
  }

  const changeGroupFilter = (newFilter) => {
    let newDateFilter
    if (dateFilter === 'Custom' && dateInterval) {
      newDateFilter = dateInterval
    } else {
      newDateFilter = dateFilter
    }

    dispatch(updateGroupFilter(name, newFilter))
    const f = `${composeFilterString(newFilter.profiles, newFilter.groups)}_${newFilter.alt || ''}`
    addQuery({ date: newDateFilter, filter: f }, location, navigate)
    setGroupFilter(newFilter)
    update(processDate(newDateFilter), processGroup(newFilter))
  }

  if (userAnalyticsEnabled) {
    return (
      <div id='adminActivity'>
        <div className='toolbar'>
          <SubHeader type='Admin' />
          <DateTimeFilter filterBy={changeDateFilter} currentFilter={dateFilter} />
          <div className='reportButtons'>
            {/* <FavoriteButton /> */}
          </div>
        </div>
        {(dateFilter !== 'Day' && dateFilter !== 'Week' && dateFilter !== 'Month') ? <CustomFilter filterBy={changeDateFilter} currentFilter={dateFilter} /> : ''}

        <FilterBy changeFilter={changeGroupFilter} currentFilter={processGroup(groupFilter)} showProfiles showGroups type='Admin' />

        <AdministratorTable
          status={status}
          generateReportClick={() => {
            const dates = processDate(dateFilter)
            const group = processGroup(groupFilter)
            const options = { group: group.groups, profile: group.profiles, sort, onlyAdmins: true, adminType: 'ALL' }
            dispatch(generateUserReport(id, dates.start.toISOString(), dates.end.toISOString(), options))
          }}
          groupFilter={processGroup(groupFilter)}
          data={adminList}
          changeOffset={(i) => {
            setPage(i)
          }}
          toggleSort={(key) => {
            if (sort.split(' ')[0] === key && sort.split(' ')[1] === 'DESC') {
              setSort(key + ' ASC')
            } else {
              setSort(key + ' DESC')
            }
          }}
          sort={sort}
          page={page}
          totalAdmins={Math.ceil(adminLength / pageTotals)}
        />
      </div>
    )
  } else {
    return (
      <div className='AdministratorTable'>
        <div className='adminPage'>
          <p>Administrator user analytics have not been turned on. To do so, go to Master Administrator Account Settings and enable Individual User Analytics</p>
        </div>
        <div className='adminPageContainer'><a className='buttonRedirect' href={redirect}>Go to Master Administrator Account Settings</a></div>
      </div>
    )
  }
}

export default Administrator
